import {countryLabels} from '../forms/countries-values'
import {useIntl} from 'react-intl'

export const useCountryLabels = () => {
    const {formatMessage} = useIntl()

    const getCountries = () => {
        return [
            {
                value: 'AE',
                label: formatMessage(countryLabels['AE']),
            },
            {
                value: 'AG',
                label: formatMessage(countryLabels['AG']),
            },
            {
                value: 'AL',
                label: formatMessage(countryLabels['AL']),
            },
            {
                value: 'AM',
                label: formatMessage(countryLabels['AM']),
            },
            {
                value: 'AR',
                label: formatMessage(countryLabels['AR']),
            },
            {
                value: 'AT',
                label: formatMessage(countryLabels['AT']),
            },
            {
                value: 'AU',
                label: formatMessage(countryLabels['AU']),
            },
            {
                value: 'BA',
                label: formatMessage(countryLabels['BA']),
            },
            {
                value: 'BE',
                label: formatMessage(countryLabels['BE']),
            },
            {
                value: 'BG',
                label: formatMessage(countryLabels['BG']),
            },
            {
                value: 'BH',
                label: formatMessage(countryLabels['BH']),
            },
            {
                value: 'BO',
                label: formatMessage(countryLabels['BO']),
            },
            {
                value: 'CA',
                label: formatMessage(countryLabels['CA']),
            },
            {
                value: 'CH',
                label: formatMessage(countryLabels['CH']),
            },
            {
                value: 'CI',
                label: formatMessage(countryLabels['CI']),
            },
            {
                value: 'CL',
                label: formatMessage(countryLabels['CL']),
            },
            {
                value: 'CO',
                label: formatMessage(countryLabels['CO']),
            },
            {
                value: 'CR',
                label: formatMessage(countryLabels['CR']),
            },
            {
                value: 'CY',
                label: formatMessage(countryLabels['CY']),
            },
            {
                value: 'CZ',
                label: formatMessage(countryLabels['CZ']),
            },
            {
                value: 'DE',
                label: formatMessage(countryLabels['DE']),
            },
            {
                value: 'DK',
                label: formatMessage(countryLabels['DK']),
            },
            {
                value: 'DO',
                label: formatMessage(countryLabels['DO']),
            },
            {
                value: 'EC',
                label: formatMessage(countryLabels['EC']),
            },
            {
                value: 'EE',
                label: formatMessage(countryLabels['EE']),
            },
            {
                value: 'EG',
                label: formatMessage(countryLabels['EG']),
            },
            {
                value: 'ES',
                label: formatMessage(countryLabels['ES']),
            },
            {
                value: 'ET',
                label: formatMessage(countryLabels['ET']),
            },
            {
                value: 'FI',
                label: formatMessage(countryLabels['FI']),
            },
            {
                value: 'FR',
                label: formatMessage(countryLabels['FR']),
            },
            {
                value: 'GB',
                label: formatMessage(countryLabels['GB']),
            },
            {
                value: 'GH',
                label: formatMessage(countryLabels['GH']),
            },
            {
                value: 'GM',
                label: formatMessage(countryLabels['GM']),
            },
            {
                value: 'GR',
                label: formatMessage(countryLabels['GR']),
            },
            {
                value: 'GT',
                label: formatMessage(countryLabels['GT']),
            },
            {
                value: 'GY',
                label: formatMessage(countryLabels['GY']),
            },
            {
                value: 'HK',
                label: formatMessage(countryLabels['HK']),
            },
            {
                value: 'HR',
                label: formatMessage(countryLabels['HR']),
            },
            {
                value: 'HU',
                label: formatMessage(countryLabels['HU']),
            },
            {
                value: 'ID',
                label: formatMessage(countryLabels['ID']),
            },
            {
                value: 'IE',
                label: formatMessage(countryLabels['IE']),
            },
            {
                value: 'IL',
                label: formatMessage(countryLabels['IL']),
            },
            {
                value: 'IS',
                label: formatMessage(countryLabels['IS']),
            },
            {
                value: 'IT',
                label: formatMessage(countryLabels['IT']),
            },
            {
                value: 'JM',
                label: formatMessage(countryLabels['JM']),
            },
            {
                value: 'JO',
                label: formatMessage(countryLabels['JO']),
            },
            {
                value: 'JP',
                label: formatMessage(countryLabels['JP']),
            },
            {
                value: 'KE',
                label: formatMessage(countryLabels['KE']),
            },
            {
                value: 'KH',
                label: formatMessage(countryLabels['KH']),
            },
            {
                value: 'KR',
                label: formatMessage(countryLabels['KR']),
            },
            {
                value: 'KW',
                label: formatMessage(countryLabels['KW']),
            },
            {
                value: 'LC',
                label: formatMessage(countryLabels['LC']),
            },
            {
                value: 'LI',
                label: formatMessage(countryLabels['LI']),
            },
            {
                value: 'LK',
                label: formatMessage(countryLabels['LK']),
            },
            {
                value: 'LT',
                label: formatMessage(countryLabels['LT']),
            },
            {
                value: 'LU',
                label: formatMessage(countryLabels['LU']),
            },
            {
                value: 'LV',
                label: formatMessage(countryLabels['LV']),
            },
            {
                value: 'MA',
                label: formatMessage(countryLabels['MA']),
            },
            {
                value: 'MD',
                label: formatMessage(countryLabels['MD']),
            },
            {
                value: 'MG',
                label: formatMessage(countryLabels['MG']),
            },
            {
                value: 'MK',
                label: formatMessage(countryLabels['MK']),
            },
            {
                value: 'MN',
                label: formatMessage(countryLabels['MN']),
            },
            {
                value: 'MO',
                label: formatMessage(countryLabels['MO']),
            },
            {
                value: 'MT',
                label: formatMessage(countryLabels['MT']),
            },
            {
                value: 'MU',
                label: formatMessage(countryLabels['MU']),
            },
            {
                value: 'MX',
                label: formatMessage(countryLabels['MX']),
            },
            {
                value: 'MY',
                label: formatMessage(countryLabels['MY']),
            },
            {
                value: 'NA',
                label: formatMessage(countryLabels['NA']),
            },
            {
                value: 'NG',
                label: formatMessage(countryLabels['NG']),
            },
            {
                value: 'NL',
                label: formatMessage(countryLabels['NL']),
            },
            {
                value: 'NO',
                label: formatMessage(countryLabels['NO']),
            },
            {
                value: 'NZ',
                label: formatMessage(countryLabels['NZ']),
            },
            {
                value: 'OM',
                label: formatMessage(countryLabels['OM']),
            },
            {
                value: 'PA',
                label: formatMessage(countryLabels['PA']),
            },
            {
                value: 'PE',
                label: formatMessage(countryLabels['PE']),
            },
            {
                value: 'PH',
                label: formatMessage(countryLabels['PH']),
            },
            {
                value: 'PL',
                label: formatMessage(countryLabels['PL']),
            },
            {
                value: 'PT',
                label: formatMessage(countryLabels['PT']),
            },
            {
                value: 'PY',
                label: formatMessage(countryLabels['PY']),
            },
            {
                value: 'QA',
                label: formatMessage(countryLabels['QA']),
            },
            {
                value: 'RO',
                label: formatMessage(countryLabels['RO']),
            },
            {
                value: 'RS',
                label: formatMessage(countryLabels['RS']),
            },
            {
                value: 'RW',
                label: formatMessage(countryLabels['RW']),
            },
            {
                value: 'SA',
                label: formatMessage(countryLabels['SA']),
            },
            {
                value: 'SE',
                label: formatMessage(countryLabels['SE']),
            },
            {
                value: 'SG',
                label: formatMessage(countryLabels['SG']),
            },
            {
                value: 'SI',
                label: formatMessage(countryLabels['SI']),
            },
            {
                value: 'SK',
                label: formatMessage(countryLabels['SK']),
            },
            {
                value: 'SN',
                label: formatMessage(countryLabels['SN']),
            },
            {
                value: 'SV',
                label: formatMessage(countryLabels['SV']),
            },
            {
                value: 'TH',
                label: formatMessage(countryLabels['TH']),
            },
            {
                value: 'TN',
                label: formatMessage(countryLabels['TN']),
            },
            {
                value: 'TR',
                label: formatMessage(countryLabels['TR']),
            },
            {
                value: 'TT',
                label: formatMessage(countryLabels['TT']),
            },
            {
                value: 'TZ',
                label: formatMessage(countryLabels['TZ']),
            },
            {
                value: 'US',
                label: formatMessage(countryLabels['US']),
            },
            {
                value: 'UY',
                label: formatMessage(countryLabels['UY']),
            },
            {
                value: 'UZ',
                label: formatMessage(countryLabels['UZ']),
            },
            {
                value: 'VN',
                label: formatMessage(countryLabels['VN']),
            },
            {
                value: 'ZA',
                label: formatMessage(countryLabels['ZA']),
            },
            {
                value: 'BD',
                label: formatMessage(countryLabels['BD']),
            },
            {
                value: 'BJ',
                label: formatMessage(countryLabels['BJ']),
            },
            {
                value: 'MC',
                label: formatMessage(countryLabels['MC']),
            },
            {
                value: 'NE',
                label: formatMessage(countryLabels['NE']),
            },
            {
                value: 'SM',
                label: formatMessage(countryLabels['SM']),
            },
            {
                value: 'AZ',
                label: formatMessage(countryLabels['AZ']),
            },
            {
                value: 'BN',
                label: formatMessage(countryLabels['BN']),
            },
            {
                value: 'BI',
                label: formatMessage(countryLabels['BI']),
            },
            {
                value: 'AO',
                label: formatMessage(countryLabels['AO']),
            },
            {
                value: 'DZ',
                label: formatMessage(countryLabels['DZ']),
            },
            {
                value: 'TW',
                label: formatMessage(countryLabels['TW']),
            },
            {
                value: 'BS',
                label: formatMessage(countryLabels['BS']),
            },
            {
                value: 'BW',
                label: formatMessage(countryLabels['BW']),
            },
            {
                value: 'GA',
                label: formatMessage(countryLabels['GA']),
            },
            {
                value: 'LA',
                label: formatMessage(countryLabels['LA']),
            },
            {
                value: 'MZ',
                label: formatMessage(countryLabels['MZ']),
            },
        ]
    }

    const getEuropeanCountries = () => {
        return [
            {
                value: 'AT',
                label: formatMessage(countryLabels['AT']),
            },
            {
                value: 'BE',
                label: formatMessage(countryLabels['BE']),
            },
            {
                value: 'HR',
                label: formatMessage(countryLabels['HR']),
            },
            {
                value: 'CZ',
                label: formatMessage(countryLabels['CZ']),
            },
            {
                value: 'DK',
                label: formatMessage(countryLabels['DK']),
            },
            {
                value: 'FI',
                label: formatMessage(countryLabels['FI']),
            },
            {
                value: 'FR',
                label: formatMessage(countryLabels['FR']),
            },
            {
                value: 'DE',
                label: formatMessage(countryLabels['DE']),
            },
            {
                value: 'GR',
                label: formatMessage(countryLabels['GR']),
            },
            {
                value: 'HU',
                label: formatMessage(countryLabels['HU']),
            },
            {
                value: 'IT',
                label: formatMessage(countryLabels['IT']),
            },
            {
                value: 'LT',
                label: formatMessage(countryLabels['LT']),
            },
            {
                value: 'NL',
                label: formatMessage(countryLabels['NL']),
            },
            {
                value: 'NO',
                label: formatMessage(countryLabels['NO']),
            },
            {
                value: 'PL',
                label: formatMessage(countryLabels['PL']),
            },
            {
                value: 'PT',
                label: formatMessage(countryLabels['PT']),
            },
            {
                value: 'RO',
                label: formatMessage(countryLabels['RO']),
            },
            {
                value: 'SK',
                label: formatMessage(countryLabels['SK']),
            },
            {
                value: 'SI',
                label: formatMessage(countryLabels['SI']),
            },
            {
                value: 'ES',
                label: formatMessage(countryLabels['ES']),
            },
            {
                value: 'SE',
                label: formatMessage(countryLabels['SE']),
            },
            {
                value: 'CH',
                label: formatMessage(countryLabels['CH']),
            },
        ]
    }

    return {getCountries, getEuropeanCountries}
}
